<template>
  <div>
    <div v-show="playlist.tracks && playlist.tracks.length > 0" id="playlist-table" class="playlist-table">
      <div class="thead">
        <div class="tr">
          <div class="th composer">
            {{ $t('COMMON.COMPOSER') }}
          </div>
          <div class="th track">
            {{ $t('PLAYLIST.DISPLAY_NAME') }}
          </div>
          <div class="th performer">
            {{ $t('COMMON.PERFORMER') }}
          </div>
          <div class="th menu" />
        </div>
      </div>
      <div class="tbody" @drop="drop($event)" @dragover.prevent>
        <div v-for="(track, index) in playlist.tracks" :key="index"
             :class="{'dragging': index === (dragItem ? dragItem.index : false),
                      'over': index === (dropItem ? dropItem.index : false) && index !== (dragItem ? dragItem.index : false),
                      'top': (index === (dropItem ? dropItem.index : '')) && (index !== (dragItem ? dragItem.index : '')) && (index !== (Number(dragItem.index) + 1)) && !dropItem.insertBottom,
                      'bottom': (index === (dropItem ? dropItem.index : '')) && (index !== (dragItem ? dragItem.index : '')) && (index !== (Number(dragItem.index) - 1)) && dropItem.insertBottom}"
             v-bind="isDraggable"
             class="tr"
             @dragstart="dragstart($event, track, index)"
             @dragend="dragend"
             @dragover="dragover($event, track, index)"
        >
          <div class="td composer">
            <a :class="{'disabled': pgnnpAudioMode}" class="btn" title="btn" @click="!pgnnpAudioMode ? setPlaylistByTrack(index) : null">
              <PlayerStaticPlayBtn :width="32" :height="32" :disabled="pgnnpAudioMode" />
            </a>
            <PlaylistTableComposer :composer="track.movement.work.people" class="composer-name" />
          </div>
          <div class="td track">
            <PlaylistTableTrack :track="track" />
          </div>
          <div class="td performer">
            <PlaylistTablePerformer :performer-list="track.performers" />
            <div v-if="filterPerformerList(track.performers).length > 0" class="performer-position">
              <div v-for="performer in filterPerformerList(track.performers)" :key="performer.people_id" class="position-info">
                {{ displayPerformerPosition(performer.position) }}: {{ displayPerformerName(performer.people) }}
                <!-- <div v-for="position in performer['performer_positions']" :key="position.id">
                  {{ displayPerformerPosition(position) }}: {{ displayPerformerName(performer) }}
                </div> -->
              </div>
            </div>
          </div>
          <div class="td play-btn">
            <a class="btn" title="btn" @click="setPlaylistByTrack(index)">
              <PlayerStaticPlayBtn :width="32" :height="32" />
            </a>
          </div>
          <div class="td play-info">
            <PlaylistTableMobileInfo :track="track" />
          </div>
          <div class="td track-menu">
            <PlayerDropdown :index="index" :open-index="openIndex" @updateOpenIndex="updateOpenIndex">
              <template slot="toggle">
                <i class="material-icons">
                  more_horiz
                </i>
              </template>
              <template slot="menu">
                <div class="track-dropdown">
                  <ul class="track-dropdown-list">
                    <li class="item pointer" @click="addToMyPlaylist(track)">
                      <i class="icon material-icons">
                        add_circle_outline
                      </i>
                      <span class="text">
                        {{ $t('TRACK.ADD_TO_PLAYLIST') }}
                      </span>
                    </li>
                    <li v-if="isUserSelf" class="item pointer" @click="confirmRemovFromPlaylist(track)">
                      <i class="icon material-icons">
                        delete
                      </i>
                      <span class="text">
                        {{ $t('TRACK.REMOVE_TRACK') }}
                      </span>
                    </li>
                    <li class="item pointer" @click="setTrackToQueue(track)">
                      <i class="icon material-icons">
                        queue_music
                      </i>
                      <span class="text">
                        {{ $t('TRACK.ADD_TO_QUEUE') }}
                      </span>
                    </li>
                  </ul>
                </div>
              </template>
            </PlayerDropdown>
          </div>
        </div>
      </div>
    </div>
    <div v-show="playlist.tracks && playlist.tracks.length === 0" class="playlist-table-empty">
      <img class="img" src="@/assets/images/player/img-playlist-empty.svg" alt="empty playlist" title="empty playlist">
      <div class="text">
        <div class="line">
          {{ $t('PLAYLIST.EMPTY_TRACKS_TEXT') }}
        </div>
        <RouterLink
          :to="{name:'playlistById', params: { locale: $i18n.localePath(), id: '8bab9510-83cc-455c-b931-80610e18f8b5' }}"
          class="try-it-link"
        >
          {{ $t('PLAYER.TRY_IT') }}  <i class="material-icons">
            chevron_right
          </i>
        </RouterLink>
      </div>
    </div>
    <PlaylistGoLoginModal
      :open="openGoToLoginModal"
      @close="openGoToLoginModal = false"
    />
    <PlaylistTrackAddingModal
      :open="openAddingModal"
      :selected-track="selectedTrack"
      :skip-playlist="playlist"
      @close="openAddingModal = false"
    />
    <PlaylistTrackRemovingingModal
      :open="openRemovingModal"
      :playlist="playlist"
      :selected-track="selectedTrack"
      @close="removeFromPlaylist"
    />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import PlayerDropdown from '@/components/player/PlayerDropdown'
import PlayerStaticPlayBtn from '@/components/player/PlayerStaticPlayBtn'

import PlaylistTablePerformer from '@/components/playlist/PlaylistTablePerformer'
import PlaylistTableComposer from '@/components/playlist/PlaylistTableComposer'
import PlaylistTableTrack from '@/components/playlist/PlaylistTableTrack'
import PlaylistTableMobileInfo from '@/components/playlist/PlaylistTableMobileInfo'
import PlaylistGoLoginModal from '@/components/playlist/PlaylistGoLoginModal'
import PlaylistTrackAddingModal from '@/components/playlist/PlaylistTrackAddingModal'
import PlaylistTrackRemovingingModal from '@/components/playlist/PlaylistTrackRemovingingModal'

import { displayTrackName, displayComposerName, displayPerformerName, displayPerformerPosition } from '@/assets/helpers/TrackHelper.js'
import { getCookie } from '@/assets/helpers/UtilHelper'

export default {
  name: 'PlaylistTable',
  components: {
    PlayerDropdown,
    PlayerStaticPlayBtn,
    PlaylistTablePerformer,
    PlaylistTableComposer,
    PlaylistTableTrack,
    PlaylistTableMobileInfo,
    PlaylistGoLoginModal,
    PlaylistTrackAddingModal,
    PlaylistTrackRemovingingModal
  },
  props: {
    playlist: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      openIndex: -1,
      openGoToLoginModal: false,
      openAddingModal: false,
      openRemovingModal: false,
      selectedTrack: {},
      dragItem: null,
      dropItem: null
    }
  },
  computed: {
    ...mapState({
      profile: state => state.user.profile,
      display: state => state.player.display,
      initialClick: state => state.player.initialClick,
      currentTime: state => state.player.currentTime,
      paused: state => state.player.paused,
      queue: state => state.player.queue,
      random: state => state.player.random,
      currentTrackId: state => state.player.id,
      pgnnpAudioMode: state => state.player.pgnnpAudioMode,
      isAnyPgnnpAudio: state => state.player.isAnyPgnnpAudio
    }),
    ...mapGetters([
      'isAuthenticated'
    ]),
    isUserSelf() {
      return this.playlist && this.profile
        ? this.playlist['user_id'] === this.profile.id
        : false
    },
    isDraggable() {
      return this.isUserSelf ? {
        'draggable': true
      } : null
    },
    tableOffsetTop() {
      let ele = document.getElementById('playlist-table')
      return ele.offsetTop
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    displayTrackName,
    displayComposerName,
    displayPerformerName,
    displayPerformerPosition,
    getCookie,
    filterPerformerList(performerList) {
      let existIdAry = []
      return performerList.filter(performer => {
        if (existIdAry.indexOf(performer.people_id) === -1) {
          existIdAry.push(performer.people_id)
          return performer
        }
        return null
      })
    },
    updateOpenIndex(newIndex) {
      this.openIndex = newIndex
    },
    addToMyPlaylist(track) {
      if (this.isAuthenticated) {
        this.selectedTrack = track
        this.openAddingModal = true
      } else {
        this.openGoToLoginModal = true
      }
    },
    confirmRemovFromPlaylist(track) {
      this.selectedTrack = track
      this.openRemovingModal = true
    },
    removeFromPlaylist(trackId) {
      if (trackId) {
        this.$emit('remove', trackId)
      }
      this.openRemovingModal = false
    },
    setPlaylistByTrack(index) {
      const isFirstPlay = this.getCookie('player_play_count') === null
      if (isFirstPlay) {
        this.$store.commit('SET_TO_PREPEND', true)
        this.$store.dispatch('PGNNP_AUDIO_NEXT')
        this.$store.commit('SET_PLAYER_INDEX', index)
        if (!this.isAnyPgnnpAudio) {
          document.querySelector('#audioPlayer').play()
          document.querySelector('#audioPlayer').pause()
        }
      } else {
        if (!this.initialClick) {
          // Trigger click-to-play policy
          document.querySelector('#audioPlayer').play()
          document.querySelector('#audioPlayer').pause()
        }
        if (this.random) {
          this.$store.commit('TOGGLE_PLAYER_RANDOM', false)
        }
        this.$store.commit('RESET_QUEUE')
        this.$store.commit('SET_PLAYLIST_TO_QUEUE', this.playlist.tracks)
        this.$store.commit('SET_PLAYER_INDEX', index)
        if (!this.paused || this.currentTime > 0) {
          this.$store.dispatch('INCREASE_PLAYING_COUNT')
        }
      }
      if (!this.display) {
        this.$store.commit('TOGGLE_PLAYER_DISPLAY', true)
      }
      this.$nextTick(() => {
        this.$store.commit('TOGGLE_PLAYER_PAUSED', false) // trigger auto play
      })
    },
    setTrackToQueue(track) {
      this.$store.commit('SET_TRACK_TO_QUEUE', track)
      if (!this.currentTrackId) {
        this.$store.commit('SET_PLAYER_INDEX', 0)
      }
      this.$store.commit('ALERT_MESSAGE', { message: 'TRACK.ADD_TO_QUEUE_SUCCESS', type: 'success' })
    },
    // drag
    drop(event) {
      if (this.dragItem && (this.dragItem.index !== this.dropItem.index)) {
        let finalPos
        if (this.dropItem.index > this.dragItem.index) {
          finalPos = this.dropItem.insertBottom ? this.dropItem.index : Number(this.dropItem.index) - 1
        } else {
          finalPos = this.dropItem.insertBottom ? Number(this.dropItem.index) + 1 : this.dropItem.index
        }
        let platAry = JSON.parse(JSON.stringify(this.playlist.tracks))
        platAry.splice(this.dragItem.index, 1)
        if (finalPos === platAry.length) {
          platAry.forEach((track, index) => {
            track.sort = index
          })
          this.dragItem.sort = finalPos
          platAry.push(this.dragItem)
        } else if (finalPos === 0) {
          this.dragItem.sort = finalPos
          platAry.splice(0, 0, this.dragItem)
          platAry.forEach((track, index) => {
            track.sort = index
          })
        } else {
          // same as finalPos === 0
          this.dragItem.sort = finalPos
          platAry.splice(finalPos, 0, this.dragItem)
          platAry.forEach((track, index) => {
            track.sort = index
          })
        }
        this.$emit('update', platAry)
      }
      this.droppedItem = event.dataTransfer.getData('item')
    },
    dragstart(event, item, index) {
      if (this.isUserSelf) {
        this.dragItem = JSON.parse(JSON.stringify(item))
        this.dragItem.index = index
        event.dataTransfer.setData('item', item)
      }
    },
    dragover(event, item, index) {
      if (this.dragItem) {
        let blockThreshold = event.target.clientHeight / 2
        let offsetTop = event.target.offsetTop + this.tableOffsetTop + blockThreshold
        let mouseClientY = event.pageY
        this.dropItem = JSON.parse(JSON.stringify(item))
        this.dropItem.index = index
        if (mouseClientY > offsetTop) {
          this.$set(this.dropItem, 'insertBottom', true)
        } else {
          this.$set(this.dropItem, 'insertBottom', false)
        }
      }
    },
    dragend(event) {
      this.dragItem = null
      this.dropItem = null
      event.dataTransfer.clearData()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

@mixin player-btn-img {
  display: inline-block;
  width: 32px;
  height: 32px;
  background-color: #ffffff;
  border-radius: 50%;
  cursor: pointer;
}

[draggable] {
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  /* Required to make elements draggable in old WebKit */
  -khtml-user-drag: element;
  -webkit-user-drag: element;
}

.playlist-table {
  display: table;
  position: relative;
  table-layout: fixed;
  width: 100%;
  &-empty {
    margin-top: 16px;
    text-align: center;
    img {
      width: auto;
    }
    .text {
      margin: 16px 0;
      font-size: 20px;
      font-weight: 500;
      line-height: 1.6;
      .line {
        padding: 0 24px;
      }
      .try-it-link {
        display: block;
        font-size: 14px;
        font-weight: 500;
        line-height: 32px;
        color: $link-hover;
        text-decoration: none;
        i {
          font-size: 14px;
          vertical-align: middle;
        }
      }
    }
  }
  [draggable] {
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    /* Required to make elements draggable in old WebKit */
    -khtml-user-drag: element;
    -webkit-user-drag: element;
    cursor: move;
  }
  .tr {
    display: table-row;
    position: relative;
    height: 48px;
    &:nth-child(2n) {
      background-color: $grey-f3;
    }
    &.dragging{
      opacity: .4;
    }
    &.over {
      opacity: .8;
    }
    &.top{
      .td {
        border-top: 2px solid #f4b93b;
      }
    }
    &.bottom {
      .td {
        border-bottom: 2px solid #f4b93b;
      }
    }
  }
  .thead {
    display: table-header-group;
    background-color: $grey-f3;
    .th {
      display: table-cell;
      padding-right: 24px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      font-weight: 700;
      color: $grey-9b;
      text-align: left;
      &.composer {
        width: 25%;
        padding-left: 36px;
      }
      &.track {
        width: 35%;
      }
      &.performer {
        width: 35%;
      }
      &.track-menu {
        width: 48px;
      }
    }
  }
  .tbody {
    display: table-row-group;
    .td {
      display: table-cell;
      height: 48px;
      // line-height: 48px;
      vertical-align: middle;
      font-size: 16px;
      font-weight: 700;
      color: $grey-7d;
      padding-right: 24px;
      &.composer {
        width: 25%;
        padding-left: 36px;
        @include ellipsis-with-nowrap();
        .btn {
          @include player-btn-img();
          user-select: none;
          &.disabled{
            cursor: not-allowed;
          }
        }
        .composer-name {
          @include default-link-hover($grey-7d);
          margin-left: 16px;
          width: calc(100% - 16px - 36px);
          display: inline;
          // color: $grey-7d; // overwrite default-link-hover
        }
        &::before {
          content: '';
          width: 0;
          height: 100%;
          display: inline-block;
          position: relative;
          vertical-align: middle;
        }
        > * {
          display: inline-block;
          vertical-align: middle;
        }
      }
      &.track {
        width: 35%;
        @include ellipsis-with-nowrap();
        .name {
          width: 100%;
          @include default-link-hover($grey-7d);
        }
      }
      &.performer {
        width: 35%;
      }
      &.play-btn,
      &.play-info {
        display: none;
      }
      &.track-menu {
        width: 48px;
        text-align: right;
      }
    }
    .performer {
      position: relative;

      .performer-position {
        display: none;
        position: absolute;
        top: 0;
        max-width: 300px;
        padding: 16px;
        border-radius: 4px;
        background: #ffffff;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
        color: #ffffff;
        transform: translateY(-100%);
        pointer-events: none;
        > .position-info {
          font-size: 16px;
          font-weight: 700;
          color: $grey-9b;
          line-height: 1.63;
          @include ellipsis-with-nowrap();
        }
        &:before{
          content: "";
          position: absolute;
          top: 100%;
          left: calc(50% - 10px);
          display: block;
          border-style: solid;
          border-color: transparent;
          border-width: 10px;
          border-bottom-width: 0;
          border-top-color: darken(#f3f3f3, 5%);
        }
        &:after{
          content: "";
          position: absolute;
          top: 100%;
          left: calc(50% - 9px);
          display: block;
          border-style: solid;
          border-color: transparent;
          border-width: 9px;
          border-bottom-width: 0;
          border-top-color: #ffffff;
        }
      }
      &:hover {
        .performer-position {
          display: block;
        }
      }
    }
  }
  //
  //
  //
  .track-dropdown {
    position: relative;
    &-list {
      z-index: 99;
      position: absolute;
      top: 8px;
      right: -8px;
      min-width: 250px;
      margin: 0; // reset ul
      padding: 0; // reset ul
      // max-height: 110px;
      border: solid 1px #f7f7f7;
      border-radius: 4px;
      background-color: white;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
      .item {
        display: block;
        width: 100%;
        height: 55px;
        line-height: 55px;
        padding-left: 16px;
        padding-right: 16px;
        letter-spacing: normal;
        color: $grey-7d;
        text-align: left;
        text-decoration: none;
        .icon {
          font-size: 20px;
        }
        .text {
          font-size: 16px;
          font-weight: 700;
          margin-left: 16px;
        }
        .icon,
        .text {
          line-height: 55px;
          vertical-align: middle;
        }
      }
      .item:hover {
        color: $link-hover;
      }
      &::before{
        z-index: 98;
        content: " ";
        position: absolute;
        top: -12px;
        right: 8px;
        display: block;
        border-style: solid;
        border-color: transparent;
        border-width: 10px;
        border-top-width: 0;
        border-bottom-color: darken(#f3f3f3, 5%);
      }
      &::after{
        z-index: 100;
        content: " ";
        position: absolute;
        top: -8px;
        right: 10px;
        display: block;
        border-style: solid;
        border-color: transparent;
        border-width: 8px;
        border-top-width: 0;
        border-bottom-color: #ffffff;
      }
    }
  }
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  .playlist-table {
    .tr {
      height: 64px;
      &:nth-child(2n) {
        background-color:#ffffff;
      }
      &:nth-child(2n+1) {
        background-color: $grey-f3;
      }
    }
    .thead {
      display: none;
    }
    .tbody {
      .td {
        padding-right: 16px;
        &.composer,
        &.track,
        &.performer {
          display: none;
        }
        &.track-menu {
          a i {
            transform: rotate(90deg);
          }
        }
        &.play-btn,
        &.play-info {
          display: table-cell;
        }
        &.play-btn {
          width: 64px;
          padding: 16px;
          > a {
            @include player-btn-img();
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .playlist-table {
    &-empty {
      img {
        width: 230px;
      }
    }
    .tr {
      height: 64px;
      &:nth-child(2n) {
        background-color:#ffffff;
      }
      &:nth-child(2n+1) {
        background-color: $grey-f3;
      }
    }
    .thead {
      display: none;
    }
    .tbody {
      .td {
        &.composer,
        &.track,
        &.performer {
          display: none;
        }
        &.track-menu {
          a i {
            transform: rotate(90deg);
          }
        }
        &.play-info {
          display: table-cell;
          padding: 0 16px;
        }
        &.play-btn {
          display: none;
          // width: 48px;
          // padding: 16px 8px; // diff
          // > a {
          //   @include player-btn-img();
          // }
        }
      }
    }
  }
}
</style>
